import { Typography } from '@ag1/ui';
import styles from './FlavorLabel.module.scss';

interface FlavorLabelProps {
  title: string;
  color: string;
}

export const FlavorLabel = ({ title, color }: FlavorLabelProps) => {
  return (
    <div className={styles.flavorContainer}>
      <div className={styles.flavorColor} style={{ backgroundColor: color }} />
      <Typography
        variant="portalText"
        size="2"
        color="grey-1-new"
        noPadding
        className={styles.flavorTitle}>
        {`${title} Flavor`}
      </Typography>
    </div>
  );
};
